export default {
  'payment-channel-card': {
    'add-account': 'Add Account',
    'processing-time': 'Processing Time',
    fee: 'Fee',
    limits: 'Limits',
    'arrival-time-description': 'Follows the withdrawal method',
    'fee-description': 'Charged according to the withdrawal method',
    'limit-description': 'Withdrawal amount follows the withdrawal method',
    limit: 'Limit',
  },
}
